import {
  CLINICAL_CRM_TABS,
  clinicalCrmTabQuery,
} from 'dashboard/routes/dashboard/clinicalCrm/navigation';

export const buildClinicalCrmMenuItems = ({
  t,
  accountScopedRoute,
  hasClinicalCrm,
  hasClinicalCrmPro,
  canAccessReports,
}) => {
  const patientItems = hasClinicalCrm
    ? [
        {
          name: 'Sales Funnel',
          label: t('SIDEBAR.SALES_FUNNEL'),
          icon: 'i-lucide-columns-3',
          to: accountScopedRoute(
            'clinical_crm_index',
            {},
            clinicalCrmTabQuery(CLINICAL_CRM_TABS.PIPELINE)
          ),
        },
      ]
    : [];

  if (canAccessReports) {
    patientItems.push({
      name: 'Basic Results',
      label: t('SIDEBAR.BASIC_RESULTS'),
      icon: 'i-lucide-chart-spline',
      to: accountScopedRoute('account_overview_reports'),
    });
  }

  const growthItems = hasClinicalCrmPro
    ? [
        {
          name: 'Growth Analytics',
          label: t('SIDEBAR.ADVANCED_ANALYTICS'),
          icon: 'i-lucide-chart-no-axes-combined',
          to: accountScopedRoute(
            'clinical_crm_index',
            {},
            clinicalCrmTabQuery(CLINICAL_CRM_TABS.ANALYTICS)
          ),
        },
        {
          name: 'Growth Exports',
          label: t('SIDEBAR.DATA_EXPORTS'),
          icon: 'i-lucide-file-archive',
          to: accountScopedRoute(
            'clinical_crm_index',
            {},
            clinicalCrmTabQuery(CLINICAL_CRM_TABS.EXPORTS)
          ),
        },
      ]
    : [];

  return { patientItems, growthItems };
};

export const buildCommercialContentMenuItem = ({
  t,
  accountScopedRoute,
  includeClinicalContent,
  includeCampaigns,
}) => ({
  name: 'Commercial Content',
  label: t('SIDEBAR.COMMERCIAL_CONTENT'),
  icon: 'i-lucide-library-big',
  children: [
    ...(includeClinicalContent
      ? [
          {
            name: 'Media Library',
            label: t('SIDEBAR.MEDIA_LIBRARY'),
            icon: 'i-lucide-images',
            to: accountScopedRoute(
              'clinical_crm_settings',
              {},
              { tab: 'media' }
            ),
          },
          {
            name: 'Quick Replies',
            label: t('SIDEBAR.QUICK_REPLIES'),
            icon: 'i-lucide-message-square-quote',
            to: accountScopedRoute(
              'clinical_crm_settings',
              {},
              { tab: 'quick_replies' }
            ),
          },
        ]
      : []),
    {
      name: 'Canned Responses',
      label: t('SIDEBAR.CANNED_RESPONSES'),
      icon: 'i-lucide-notebook-tabs',
      to: accountScopedRoute('canned_list'),
    },
    {
      name: 'Macros',
      label: t('SIDEBAR.MACROS'),
      icon: 'i-lucide-toy-brick',
      to: accountScopedRoute('macros_wrapper'),
    },
    ...(includeCampaigns
      ? [
          {
            name: 'Outbound Campaigns',
            label: t('SIDEBAR.OUTBOUND_CAMPAIGNS'),
            icon: 'i-lucide-megaphone',
            to: accountScopedRoute('campaigns_livechat_index'),
          },
        ]
      : []),
  ],
});
